import React from 'react';
import { useField, UseFieldConfig } from 'react-final-form';
import { MultiSelect } from '../Select/MultiSelect';

type MultiSelectFieldProps<ValueType> = Omit<
  React.ComponentProps<typeof MultiSelect>,
  'value' | 'onChange' | 'error' | 'errorText' | 'multiple'
> & {
  initialValue?: ValueType[];
  validate?: UseFieldConfig<ValueType[]>['validate'];
  onChange?: (value: ValueType[]) => void;
  forceShowErrors?: boolean;
};

const EMPTY_VALUE = [] as const;

export const MultiSelectField = <ValueType extends string = string>({
  name,
  validate,
  initialValue,
  onChange,
  forceShowErrors,
  ...rest
}: MultiSelectFieldProps<ValueType>) => {
  const { input, meta } = useField<ValueType[]>(name, {
    validate,
    initialValue,
  });
  const hasError =
    !!meta.error && (forceShowErrors || meta.touched || meta.modified);

  return (
    <MultiSelect
      {...rest}
      error={hasError}
      errorText={hasError ? meta.error : undefined}
      name={name}
      onChange={(event) => {
        const nextValue = event.target.value as ValueType[];
        input.onChange(nextValue);
        onChange?.(nextValue);
      }}
      value={Array.isArray(input.value) ? input.value : EMPTY_VALUE}
    />
  );
};
